import './App.css';
import './estilos.css'
import Header from './layout/Header.js'
import Footer from './layout/Footer.js'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MenuPollos from './vistas/MenuPollos.js';
import BuscaFactura from './vistas/BuscaFactura.js';
import Inicio from './vistas/Inicio.js';
import Carrito from './vistas/Carrito.js';
import { useEffect, useState } from 'react';
//import swal from 'sweetalert2'
import swal from 'sweetalert'
import Producto from './vistas/Producto.js';
import MenuPromociones from './vistas/MenuPromociones.js';
import Contacto from './vistas/Contacto.js';
import TerminosCondiciones from './vistas/TerminosCondiciones.js';
import Historia from './vistas/Historia.js';
import PoliticasPrivacidad from './vistas/PoliticasPrivacidad.js';
import Sucursales from './vistas/Sucursales.js';

function App() {

	const ruta_servidor = ""
	//const ruta_servidor = "/pagina"
	const [cartItems, setCartItems] = useState("[]");
	const agregarItemCarro = (producto, set_cantidad = 0) => {
		let carrito = []
		let carritoLocalS = localStorage.getItem('carrito')
		if (carritoLocalS && carritoLocalS != "" && carritoLocalS.length != 2) { //2 porque es el string '[]'
			carrito = JSON.parse(carritoLocalS)
		}
		//busco si el item ya existe, por ende solo aumentar la cantidad
		const existingProducto = carrito.findIndex(
			(item) => item.producto.id === producto.id
		)
		if (existingProducto >= 0) {
			if (set_cantidad == 0) {
				carrito[existingProducto].cantidad++;
			} else {
				carrito[existingProducto].cantidad = set_cantidad;
			}
		} else {
			carrito.push({ producto, cantidad: 1 });
		}
		setCartItems(JSON.stringify(carrito))
		let carritoJSON = JSON.stringify(carrito);
		localStorage.setItem('carrito', carritoJSON);
		swal("Agregado al carrito", {
			buttons: false,
			timer: 1000,
			timerProgressBar: true,
		});
	}
	const quitarItemCarro = (producto) => {
		let carrito = []
		if (cartItems != null && cartItems != "") {
			var carrito_parseado = JSON.parse(cartItems)
			carrito = [...carrito_parseado]
		}
		//busco si el item ya existe, por ende solo aumentar la cantidad
		const existingProducto = carrito.findIndex(
			(item) => item.producto.id === producto.id
		)
		if (existingProducto >= 0) {
			carrito.splice(existingProducto, 1)
		} else {
			alert("elemento no existe en el carrito, actualice la página")
		}
		//console.log("arma",carrito)
		setCartItems(JSON.stringify(carrito))
		let carritoJSON = JSON.stringify(carrito);
		localStorage.setItem('carrito', carritoJSON);
	}
	//limpiar los items del carrito
	const limpiarCarro = () => {
		let carrito = []
		setCartItems(JSON.stringify(carrito))
		let carritoJSON = JSON.stringify(carrito);
		localStorage.setItem('carrito', carritoJSON);
	}
	useEffect(() => {
		if (localStorage.getItem('carrito'))
			setCartItems(localStorage.getItem('carrito'))
	}, [cartItems])
	const getCantidadItems = () => {
		//obtengo la cantidad de items que hay en el carrito
		if (typeof cartItems == "undefined") {
			return 0
		}
		let cantidad = 0
		JSON.parse(cartItems).forEach(item => {
			cantidad += parseInt(item.cantidad)
		})
		console.log("cant", cantidad)
		return cantidad
	}
	const getPrecioTotalItems = () => {
		if (typeof cartItems == "undefined") {
			return 0
		}
		let precio = 0
		JSON.parse(cartItems).forEach(item => {
			precio += item.producto.precio_venta * item.cantidad
		})
		return precio
	}

	return (
		<body className="container-lg">
			<div className="bar-loader" id="bar-loader-layout" style={{ display: "none" }}></div>
			{/* <Header cantidadItems={typeof cartItems == "undefined" ? 0 : JSON.parse(cartItems).length} /> */}
			<Header cantidadItems={getCantidadItems()} precioTotalItems={getPrecioTotalItems()} />
			<main id="RenderBodyDiv" >
				{/* {token} */}
				<Router basename={ruta_servidor} >
					<Routes>
						<Route path="/" element={<Inicio agregarItemCarro={agregarItemCarro} />} />
						<Route path="/inicio" element={<Inicio agregarItemCarro={agregarItemCarro} />} />
						<Route exact path="/menuPollos" element={<MenuPollos agregarItemCarro={agregarItemCarro} />} />
						<Route exact path="/menuPromociones" element={<MenuPromociones agregarItemCarro={agregarItemCarro} />} />
						<Route exact path="/buscaFactura" element={<BuscaFactura />} />
						<Route exact path="/carrito" element={<Carrito agregarItemCarro={agregarItemCarro} quitarItemCarro={quitarItemCarro} limpiarCarro={limpiarCarro} />} />
						<Route exact path="/producto/:name" element={<Producto agregarItemCarro={agregarItemCarro} />} />
						<Route exact path="/contacto" element={<Contacto />} />
						<Route exact path="/politicasPrivacidad" element={<PoliticasPrivacidad />} />
						<Route exact path="/historia" element={<Historia />} />
						<Route exact path="/terminosCondiciones" element={<TerminosCondiciones />} />
						<Route exact path="/sucursales" element={<Sucursales />} />
						<Route path="*" element={<div><h2>404-no pudimos encontrar esta página</h2></div>} />
						{/* <Link to="/about">Sobre</Link> */}
					</Routes>
				</Router>

			</main>




			<Footer />

			<script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyAVhNup7xHWTNoBToHIY1SFHoxUXRb-2SI&sensor=false&libraries=places,geometry&language=es-PE&sessiontoken=10191b72-735b-48f1-9e9a-b2e1a6910c9a"></script>
			<script src="/bundles/locationSSFHjs?v=RQk2YI5fa08qE91U5HTIf8fcQBmdEW-57OwxuhDhrGs1"></script>



		</body >
	);
}

export default App;
